import { Grid } from "@mui/material";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import AppContainer from "../../../components/AppContainer";
import AppLoader from "../../../components/AppLoader";
import useNotifications from "../../../components/hooks/useNotifications";
import NavigationDrawer from "../../../components/NavigationDrawer/index";
import NotificationCard from "../../../components/NotificationCard";
import { t } from "i18next";

const Notifications = () => {
  const userData = useSelector((state) => state.userData.user);
  const { notificationsLoading, allNotifications, fetchAllNotifications } =
    useNotifications();

  useEffect(() => {
    if (userData) {
      fetchAllNotifications();
    }
  }, [userData]);

  return (
    <NavigationDrawer>
      <AppLoader isVisible={notificationsLoading} />
      <AppContainer
        primaryHeading={t("notifications")}
        secondaryHeading={t("viewNotifications")}
      >
        <Grid container spacing={2} alignItems="stretch">
          {allNotifications.map((val, index) => {
            return (
              <Grid
                key={index}
                item
                xs={12}
                sm={6}
                md={4}
                style={{ display: "flex" }}
              >
                <NotificationCard data={val} index={index} />
              </Grid>
            );
          })}
        </Grid>
      </AppContainer>
    </NavigationDrawer>
  );
};

export default Notifications;
